
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
    <div class="giga-action_links">
      <div class="giga-action_row">
        <b-button
          :to="{ name: 'ReglementaireOverview',  params: { id: id } }"
          :class="[{ activeTab: $route.path.split('/').includes('articles') }]"
          pill
        >
          {{ $t("articles_list") }}</b-button
        >
        <b-button
          :to="{ name: 'ReglementaireDownloads',  params: { id: id } }"
          :class="[{ activeTab: $route.path.split('/').includes('downloads') }]"
          pill
        >
          {{ $t("downloads_list") }}</b-button
        >

<!--        <div class="col-sm-5 col-lg-4 d-flex align-items-right">
          <div class="search-field">
            <div class="search-field_input">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z"></path></svg>
              <input type="text" placeholder="Chercher un document">
            </div>
          </div>
        </div>-->
      </div>
      
    </div>
</template>

<script>
export default {
  name: 'ReglementaireLink',
  props:['id']
};
</script>
